import React from 'react';
import ReorderList from "../../../../core/gd-ui/sortable-list-4/reorder-list";
import NavigationMenuItem from "../../menu-items/menu-item";
import NavigationMenuAdd from "../../menu-items/menu-add/menu-add";
import {EVENT_BUS_MENU_RERENDER} from "../../sections/const";
import MenuSectionController_Settings from "./local-settings";

type Props = {
    settingsKey         : string;
    showAdd?            : boolean
    countVisibleItems   : number
    components          : any[]
    moreTitle           : string
    newItemTitle?       : string
    level?              : number    // indentation level of the "more"/"show less" item

    onReorderEnd?       : callback
    onClickNew?         : callback
}

export default function MainMenu_SectionReorderableWithMore(props: Props) {

    const localSettings = new MenuSectionController_Settings(props.settingsKey, true)

    const showAllItems = localSettings.showAllItems

    const moreItemsCount= props.components.length - props.countVisibleItems
    const showMore= moreItemsCount > 0

    const components = moreItemsCount > 0 && showAllItems ?
                                                props.components :
                _.take(props.components, props.countVisibleItems)

    const icon = showAllItems ? "i5-long-arrow-up" : "i5-long-arrow-down"
    const title = showAllItems ? "Show less" : props.moreTitle
    const countHiddenItems = showAllItems ? 0 : moreItemsCount

    const toggleShowAllItems = ()=>{
        localSettings.showAll = !showAllItems
        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onReorderEnd = (items: any[])=>{
        if(props.onReorderEnd) props.onReorderEnd(items)
    }

    const onClickNew = ()=>{
        if(props.onClickNew) props.onClickNew()
    }

    return (
        <>
            <ReorderList key            = {gd.utils.guid()}
                         items          = {components}
                         keyFunction    = {(item)=>item.id}
                         onReorder      = {onReorderEnd}/>

            {showMore &&
                <NavigationMenuItem icon    = {icon}
                                    counter = {countHiddenItems}
                                    name    = {title}
                                    level   = {props.level}
                                    onClick = {toggleShowAllItems}/>}

            {props.showAdd &&
                <NavigationMenuAdd name     = {props.newItemTitle || "New"}
                                   onClick  = {onClickNew}/>}
        </>
    );
}
